import { type ReactNode } from 'react'

import { LabeledValue } from '@loadsmart/miranda-react'

import { type OpenDockStopAppointment } from '../../domain/Shipment'
import {
  formatLoadType,
  formatScheduledAt,
  formatTimeRange,
} from '../../presenters/openDockAppointmentPresenter'

export type OpenDockAppointmentSummaryProps = {
  facilityName?: string
  facilityTimezone?: string
  stopAppointment?: OpenDockStopAppointment
  betweenLoadTypeAndScheduledAt?: ReactNode
}

export function OpenDockAppointmentSummary({
  facilityName,
  facilityTimezone,
  stopAppointment,
  betweenLoadTypeAndScheduledAt,
}: OpenDockAppointmentSummaryProps) {
  return (
    <>
      <LabeledValue>
        <LabeledValue.Label>Warehouse</LabeledValue.Label>
        <LabeledValue.Value>{facilityName ?? '-'}</LabeledValue.Value>
      </LabeledValue>
      <LabeledValue>
        <LabeledValue.Label>Load type</LabeledValue.Label>
        <LabeledValue.Value>
          {stopAppointment ? formatLoadType(stopAppointment.loadType) : '-'}
        </LabeledValue.Value>
      </LabeledValue>
      {betweenLoadTypeAndScheduledAt}
      <LabeledValue>
        <LabeledValue.Label>Scheduled At</LabeledValue.Label>
        <LabeledValue.Value>
          {stopAppointment
            ? formatScheduledAt(
                stopAppointment.start,
                formatTimeRange(stopAppointment.start, stopAppointment.end),
                facilityTimezone
              )
            : '-'}
        </LabeledValue.Value>
      </LabeledValue>
    </>
  )
}
